import React, {useContext} from 'react';
import UploadBtn from "./uploadFile/UploadBtn";
import UploadFromLink from "./uploadFile/UploadFromLink";
import File from "./uploadFile/File";
import dataConnectorContext from "../DataConnector/context/dataConnectorContext"
import ConnectorHeader from "./Components/ConnectorHeader";
import axios from "axios";
export default function UploadFile() {
    const context = useContext(dataConnectorContext)
    const allowToContinue = () => {
            return context.state.files.find(file => file.status === 'done')
    }
    return (
                   <div className="flex-column justify-content-between upload-file flex-grow-1">
                        <ConnectorHeader title="Upload File">
                            You can upload as many files as you want. Currently we support .csv and .xls files and your file size souldn’t exceed 2GBs.
                        </ConnectorHeader>
                       {context.state.files.map((file,key) => (
                           <File
                               key={key}
                               file={file}
                           />
                           ))}
                       <UploadBtn/>
                       {/*<UploadFromLink/>*/}
                       <div style={{marginTop:32}} className="d-flex justify-content-end">
                           <div style={{padding:'10px 28px'}} onClick={() => context.dispatch({type: 'set_page', value: 'Assemble Input Source'})} className={`btn btn-outline mb-0 mt-3 mr-3`}>Add New Source Type</div>
                           <div style={{padding:'10px 28px'}} onClick={() => {context.dispatch({type: 'set_page', value: 'Generate Connector'})
                           }} className={`btn mb-0 mt-3 ${allowToContinue() ? '' : 'btn-disable'}`}>Finish Adding Resources & Continue</div>
                       </div>
                   </div>
    );
}
